export default {"src":"/_next/static/media/mileprogram-benefit-02.ab561bf4.svg","height":143,"width":141,"blurWidth":0,"blurHeight":0};